export var unpackOutageEvent = function (data) {
    return data.map(function (feed) { return ({
        title: feed.title,
        description: feed.description,
        date: feed.date,
    }); });
};
export var unpackPartnerCheck = function (data) {
    return data.blocked_new_submission;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHVibGljLm1hcHBlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInB1YmxpYy5tYXBwZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLElBQU0saUJBQWlCLEdBQUcsVUFDL0IsSUFBd0M7SUFFeEMsT0FBQSxJQUFJLENBQUMsR0FBRyxDQUFDLFVBQUMsSUFBSSxJQUFLLE9BQUEsQ0FBQztRQUNsQixLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7UUFDakIsV0FBVyxFQUFFLElBQUksQ0FBQyxXQUFXO1FBQzdCLElBQUksRUFBRSxJQUFJLENBQUMsSUFBSTtLQUNoQixDQUFDLEVBSmlCLENBSWpCLENBQUM7QUFKSCxDQUlHLENBQUM7QUFFTixNQUFNLENBQUMsSUFBTSxrQkFBa0IsR0FBRyxVQUFDLElBQWtDO0lBQ25FLE9BQU8sSUFBSSxDQUFDLHNCQUFzQixDQUFDO0FBQ3JDLENBQUMsQ0FBQyJ9